<div class="dialog-header flex flex-col">
  <div class="flex flex-row items-center justify-between">
  <div class="flex flex-row items-center">
    <span class="dialog-title fs-18 fw-600">{{ data.row?.name }}</span>   
  </div>
  <div class="flex flex-row justify-end">
  <mat-icon svgIcon="close" class="icon-lg justify-end cursor-pointer ml-8" (click)="dialogRef.close()"></mat-icon>
  </div> 
  </div>
  <div class="flex flex-row items-center">
    @if (!data.loading && detail.length > 0) {
    <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    }
    <app-environment-paginator class="ml-auto pb-24" [length]="searchedResult.length || detail.length" [pageIndex]="pageIndex"
      [pageSize]="paginationSize" (page)="onPageChange($event)"></app-environment-paginator>
  </div>
  </div>
<mat-divider class="neutral-2 ml-16 mr-16"></mat-divider>

<div class="dialog-body">
  @if (data.loading) {
    <div class="loader-section p-16">
      <div class="flex flex-row mb-8">
        @for (col of detailColumnKeys; track col) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
      @for (item of [1, 2, 3]; track $index) {
        <div class="flex flex-row">
          @for (col of detailColumnKeys; track col) {
            <div class="loader-style">
              <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (!data.loading && detail.length > 0) {
    <div class="flex flex-col border-radius route-table envt-schedule mb-16 mt-8 ml-16 mr-16">
      <app-environment-table class="runbook-table" [ngClass]="{'disabled': showLoader}"
        [displayColumns]="displayColumns" [showSkeletonLoader]="showLoader"
        [initialDataSource]="baseImageData" [dataLoading]="showLoader" [dataSourceLength]="true"
        [initialCreate]="false" (pageChanged)="onPageChange($event)"
        [searchTerm]="searchTerm" (searchedResults)="searchedItems($event)"
        pageName="environmentBaseImageDetail"></app-environment-table>
    </div>
    
  }

  @if (!data.loading && detail.length === 0) {
    <div class="flex flex-col items-center mt-32 mb-32">
      <div class="flex mt-6">{{'BASE_IMAGE.NO_DETAIL_DATA' | transloco}}</div>
    </div>
  }
</div>
